import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";
import 'slick-carousel';


@Options({
    template: false
})
export default class HorizontalHeroGallery extends Marionette.View<Backbone.Model>{

    pluginContainer = null;

    config?: object;

    constructor(options?:object, config?:object) {
        super(options);
        this.config = config || {};

        this.attachResizeEvent();

        this.pluginContainer = document.querySelector('.plugin-container');
        this.pluginContainer.classList.add('plugin-container--sticky');
    }

    attachResizeEvent() {
        window.addEventListener('resize', event => {
            this.updateContentPosition();
        });
    }

    updateContentPosition() {
        let pageWidth = Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        );


        let contentHeight = this.pluginContainer.scrollHeight;
        this.pluginContainer.removeAttribute('style');

        document.querySelector('footer').style.marginTop = '0px';
        if (pageWidth > 768) {
            // this.pluginContainer['style'].marginBottom = (contentHeight + VISIBLE_CONTENT_AREA_PX) + 'px';
            // this.pluginContainer['style'].marginBottom = contentHeight + 'px';
            document.querySelector('footer').style.marginTop = contentHeight + 'px';
        }

        this.pluginContainer.classList.add('plugin-container--sticky-inited');
    }

    renderGallery($el:JQuery) {

        if(window.CMS && window.CMS.config && window.CMS.config.mode == "draft") {
            return;
        }

        const config = this.config;
        window.setTimeout(() => {
            ($el as any).slick(config);
        }, 0);

        ($el as any).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            let isInverted = $(`[data-slick-index="${nextSlide}"]`, $el).hasClass('gallery__item--inverted');
            $el.closest('.hero').toggleClass('hero--inverted', isInverted);
            $('body').toggleClass('use-inverted-header', isInverted);
        });
    }

    startGoodBrowsers() {
        if (document.readyState === 'complete') {
            this.updateContentPosition();
        } else {
            window.addEventListener('load', () => {
                this.updateContentPosition();
            });
        }
    }

    onRender() {
        this.renderGallery(this.$el);
        this.startGoodBrowsers();
    }
}



// WEBPACK FOOTER //
// ./@modules/views/horizontal-hero-gallery.ts